/* eslint-disable import/prefer-default-export */
const remainingText = (a) => a.toUpperCase()
export const capitalize = (str) => str.replace(/(^|\s)\S/g, remainingText)
